<template>
    <table style="width: 100%;" cellspacing="0" v-if="order">
        <tr class="tr-bordered-bottom">
            <td><T>Блюдо</T></td>
            <td style="text-align: end; vertical-align: top"><T>Кол-во</T></td>
            <td style="text-align: end; vertical-align: top"><T>Сумма</T></td>
        </tr>
        <tr v-for="item in order.items" :key="item.line_guid">
            <td style="font-size: 1.12em;">
            {{ item.name }}
                <div class="text-caption ml-3" v-for="modifier, n in item.modifiers" :key="n">
                    x{{modifier.quantity}} {{modifier.name}}
                </div>
            </td>
            <td style="text-align: end; vertical-align: top">x{{ item.quantity }}</td>
            <td style="text-align: end">
                ={{
                    item.id === deliveryDishId
                    ? deliverySum.toFixed(2)
                    : (item.sum + Math.abs(item.discount_sum)).toFixed(2)
                }}
           </td>
        </tr>
        <tr style="font-weight: 500" class="tr-bordered-top">
            <td><T>Сумма по чеку</T></td>
            <td colspan="2" align="right">={{ (Math.abs(order.discount_sum) - Math.abs(order.markup_sum) + getOrderSum()).toFixed(2) }}</td>
        </tr>
        <tr style="font-weight: 500" v-for="discount in order.discounts" :key="discount.code">
            <td>{{ discount.name }}</td>
            <td colspan="2" align="right">-{{ Math.abs(discount.sum).toFixed(2) }}</td>
        </tr>
        <tr style="font-weight: 500" v-for="markup in order.markups" :key="markup.code">
            <td>{{ markup.name }}</td>
            <td colspan="2" align="right">+{{ Math.abs(markup.sum).toFixed(2) }}</td>
        </tr>
        <tr style="font-size: 1.2em; font-weight: 500">
            <td><T>Итого</T></td>
            <td colspan="2" align="right">={{ (getOrderSum()).toFixed(2) }}</td>
        </tr>
        <tr v-if="transaction_status === 'PAYED'" style="font-size: 1.5em; font-weight: 500; color: green;">
            <td colspan="3" align="right"><T>ОПЛАЧЕНО</T></td>
        </tr>
    </table>
</template>

<script>
export default{
    props: {
        order: Object,
        transaction_status: String,
        deliveryDishId: {
            type: [String, Number],
            required: false
        },
        deliverySum: {
            type: Number,
            default: 0
        }
    },
    methods: {
        getOrderSum() {
            const baseTotal = this.order.order_total
            
            if (!this.deliveryDishId || !this.order.items) {
                return Number(baseTotal.toFixed(2));
            }

            const deliveryItem = this.order.items.find(
                item => item.id === this.deliveryDishId
            );
            if (deliveryItem) {
                const itemPrice = deliveryItem.sum + Math.abs(deliveryItem.discount_sum);
                if (itemPrice === 0) {
                    return Number((baseTotal + this.deliverySum).toFixed(2));
                }
            }

            return Number(baseTotal.toFixed(2));
        }
    },
    async mounted(){

  },
}
</script>

<style>
    .tr-bordered-top td{
        border-top: 1px solid #000;
    }

    .tr-bordered-bottom td{
        border-bottom: 1px solid #000;
    }
</style>